import "./GalleryGrid.scss";
import PropTypes from "prop-types";
import { ITXImage } from "components/ITXImage";
import { GSAPAnimationGalleryGrid } from "components/GSAP";

export const GalleryGrid = ({ component }) => {
  const { fullWidth, marginBottom, maxElementsRow, images } = component.fields;

  const isFullWidth = !!fullWidth.staticValue;

  return (
    <GSAPAnimationGalleryGrid
      className={`gallery-grid ${marginBottom.staticValue[0]} ${
        isFullWidth ? "gallery-grid__desktop-p-20" : "globalComponentContainer"
      }`}
    >
      <div
        className={`grid columns--${maxElementsRow.staticValue[0]} ${
          isFullWidth ? "desktop-gap-8" : ""
        }`}
      >
        {images.map((img, pos) => {
          const { id, url, name, width, height } = img.galleryImage.staticValue;

          return (
            <div
              key={`${id}-${pos}`}
              className={`grid__item d-flex justify-content-center itemG ${
                isFullWidth ? "full-width" : ""
              }`}
            >
              <figure>
                <ITXImage
                  id={id}
                  url={url}
                  name={name}
                  width={width}
                  height={height}
                  alt={img.galleryCaption.staticValue || name}
                />
              </figure>
              <figcaption>{img.galleryCaption.staticValue}</figcaption>
            </div>
          );
        })}
      </div>
    </GSAPAnimationGalleryGrid>
  );
};

GalleryGrid.propTypes = {
  component: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    controlId: PropTypes.arrayOf(PropTypes.string).isRequired,
    fields: PropTypes.shape({
      images: PropTypes.arrayOf(
        PropTypes.shape({
          galleryImage: PropTypes.shape({
            id: PropTypes.string,
            path: PropTypes.string,
            url: PropTypes.string,
            title: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            darkMode: PropTypes.bool,
          }).isRequired,
          galleryCaption: PropTypes.shape({
            staticValue: PropTypes.string.isRequired,
          }).isRequired,
        })
      ).isRequired,
      maxElementsRow: PropTypes.shape({
        staticValue: PropTypes.arrayOf(PropTypes.string).isRequired,
      }).isRequired,
      marginBottom: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf([
            "margin__bottom__0",
            "margin__bottom__80",
            "margin__bottom__160",
            "margin__bottom__240",
          ])
        ).isRequired,
      }),
      fullWidth: PropTypes.shape({
        staticValue: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }),
};
